import { CmsProperty } from '../../api/models/Shared.types';
import { Log } from '@lightningjs/sdk';
import { SettingsKeys } from '../../api/models/TranslationKeys';
import { recordingPageTypeToAnalytics } from '../../api/analytics/AnalyticsUtil';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { GridDataSource } from '../cms/GridDataSource';
import { ReminderGridDataSource } from './ReminderGridDataSource';

export class ReminderPageDataSource {
  private _channels: ChannelModel[] | undefined;
  private readonly backend: Backend;
  private readonly menuPageType: string;

  constructor(backend: Backend, menuPageType: string, channels: ChannelModel[] | undefined = undefined) {
    this.backend = backend;
    this.menuPageType = menuPageType;
    this._channels = channels;
  }

  set channels(_channels: ChannelModel[]) {
    this._channels = _channels;
  }

  getReminderContent(): Promise<GridDataSource | undefined> {
    if (!this._channels) {
      Log.error('channels is not yet set for reminders page');
      return Promise.resolve(undefined);
    }
    const ds = new ReminderGridDataSource(this.backend, this._channels, this.pageProperties);
    return ds.load();
  }

  get pageProperties(): CmsProperty[] {
    let properties;
    properties = this.backend.globalSettings.stringArray(SettingsKeys.propertiesRemindersRibbon) as CmsProperty[];
    properties = properties
      ? properties
      : [CmsProperty.ShowProgress, CmsProperty.UseBestSchedule, CmsProperty.ShowScheduleInfo];
    return properties;
  }

  logPageView(backend: Backend, title: string) {
    backend.logService.trackPageView(recordingPageTypeToAnalytics(this.menuPageType) || 'undefined', title);
  }
}
